import gql from 'graphql-tag'

export const trackAnalyticsQuery = gql`
  query OrderForAnalyticsQuery($orderId: ID!) {
    order(orderId: $orderId) {
      _id
      countryCode
      isConfirmed
      isScheduled
      fullCode
      deliverAt
      channel
      deliveryType
      paymentType
      buyerName
      email
      totalPrice
      amountToPay
      baseItemsPrice
      didTrack
      realPrice: baseTotalPrice
      review {
        _id
        rating
      }
      website {
        _id
        name
      }
      store {
        _id
        name
      }
      createdAt
      deliverAt
      items(includeDeletedItems: true) {
        product {
          _id
          name
          categories {
            _id
            name
          }
        }
        amount
        realPrice: baseUnitPrice
        unitPrice
        comment
        description
        deletedAt
        descriptionItems {
          title
          selections
        }
      }
      amountPaid
    }
  }
`
